module.exports = __webpack_public_path__ + "static/media/macho-zun.7d58d13b.svg";